/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { use } from 'fierry/react';

import Validation from 'solis/claude/action/validation';

import BoundSlider from 'solis/navigation/input/slider';


const isDisabled = (result) =>
{
  return result.issues.length > 0;
};


export default (props) =>
{
  const result = use(Validation);

  return <BoundSlider {...props} disabled = {isDisabled(result)} />;
};
